// extracted by mini-css-extract-plugin
export default {"root":"jqiPQ__root","button":"V0yBm__button YB6BY__iconButton vb-icon"};